import { Component, EventEmitter, Output, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
  @Output() toggleMobileMenu: EventEmitter<boolean | null> = new EventEmitter();
  isMenuOpened = false;
  loginDisplay = false;

  private readonly _destroying$ = new Subject<void>();

  constructor(private router: Router) {
    router.events.subscribe(() => {
      this.isMenuOpened = false;
      document.body.style.overflow = 'visible';
    });
  }

  ngOnInit(): void {}

  ngOnDestroy() {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  onMenuClick(): void {
    this.isMenuOpened = !this.isMenuOpened;

    document.body.style.overflow = this.isMenuOpened ? 'hidden' : 'visible';

    this.toggleMobileMenu.emit(null);
  }
}
